function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import Auth from '../../functions/authenticate';
export default class extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onClick", event => {});
  }
  componentDidMount() {
    Auth.SignOut();
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex-screen-container"
    }, /*#__PURE__*/React.createElement("section", {
      className: "auth-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner-container"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "primary logo"
    }, "PLUNK"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "You have been logged out."), /*#__PURE__*/React.createElement("footer", {
      className: "hide"
    }, "Need an account? \xA0", /*#__PURE__*/React.createElement("a", null, "Sign Up"))));
  }
}